module.exports = __webpack_public_path__ + "public/media/NAPA.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lOGO PNG/NAPA.png
// module id = ./images/partners/lOGO PNG/NAPA.png
// module chunks = 0